import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/SwimmingPoolFields.json";
import {
    deleteSwimmingPool,
    getSwimmingPoolWithPagination
} from "adminApi/SwimminPoolApi/SwimminPoolApi";

function FilterStatus(data) {
    const result = data.map(item => ({
        ...item,
        status: (
            <span className={`badge bg-${
                item.status === 'Active' ? 'success' :
                item.status === 'Inactive' ? 'danger' :
                item.status === 'Under Maintenance' ? 'warning' :
                item.status === 'Booked' ? 'info' : 'danger'
            }`}>
                {item.status}
            </span>
        )
    }));
    return result;
}

const SwimmingPoolListTable = () => {
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];
    const { tabledata } = fields
    // Fetch Hook
    const { data, meta, loading, error, refetch } = usePaginatedFetch(getSwimmingPoolWithPagination, {
        page,
        limit,
        search: debouncedSearch,
        title: "Swimming Pool List",
    });

    const displayFields = generateDisplayFields(tabledata);

    const FilderdData = FilterStatus(data);
    // Table Hook
    const { formattedData, columns } = useTableConfig({
        data: FilderdData,
        page,
        limit,
        canShowAction,
        refetch,
        IsDelete: true,
        config: {
            entityName: "Swimming Pool List",
            editUrl: "edit-swimming-pool",
            idKey: "swimming_pool_id",
            deleteApi: deleteSwimmingPool,
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const onPageChange = (p) => setPage(p);
    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
                fileName: "Swimming Pool",
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch: handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange,
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange,
            }}
        />
    );
};

export default SwimmingPoolListTable;
